<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()"  >添加</el-button >
            <el-button  class="top-btn" type="success" plain @click="handleBatch(1)">启用</el-button >
            <el-button  class="top-btn" type="info"    plain @click="handleBatch(2)">禁用</el-button >
            <el-button  class="top-btn" type="danger"  plain @click="handleBatch(3)">删除</el-button >
        </div>

        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" row-key="id" empty-text="暂无栏目" max-height="650"  style="width:100%;">
                <el-table-column type="selection"  width="100" align="center"> </el-table-column>
                <el-table-column prop="title"      label="名称"    width="260" ></el-table-column>
                <el-table-column prop="path"       label="路径"    width="200" > </el-table-column>
                <el-table-column prop="identify"   label="控制器"  width="200" > </el-table-column>
                <el-table-column prop="sort_id"    label="排序"    width="160"   align="center" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort_id" @change="handleSort(scope.row)" size="small" style="width:100px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="status"    label="栏目状态"    width="160"   align="center" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="small"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="small"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        


        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="name" placeholder="请输入栏目名称"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目路径：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="path" placeholder="请输入栏目路径"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目控制器：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="identify" placeholder="请输入栏目控制器"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目排序：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="sort" placeholder="请输入排序(正序排列)"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>栏目状态：</p>
                </el-col>
                <el-col :span="18">
                    <el-radio v-model="status" :label="1" border>启用</el-radio>
                    <el-radio v-model="status" :label="0" border>禁用</el-radio>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>是否为功能模块：</p>
                </el-col>
                <el-col :span="18">
                    <el-radio v-model="is_module" :label="1" border style="width:84px">是</el-radio>
                    <el-radio v-model="is_module" :label="0" border style="width:84px">否</el-radio>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>选择所属父级：</p>
                </el-col>
                <el-col :span="18">
                    <el-cascader v-model="pid" :options="tableData" :props="{ checkStrictly: true,label:'title',value:'id',emitPath:false, expandTrigger: 'hover' }" separator="-" clearable></el-cascader>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { columns, columns_add, columns_put, columns_del } from '@/api/platform.js'

export default {
    data() {
        return {
            tableData: [],
            ids:[],          // table 选中数据的 id 数组集合
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'添加栏目',
            id:'',           //  有id 是修改  没有id是添加
            name:'',
            path:'',
            identify:'',
            sort:1,
            status:0,
            is_module:0,
            pid:'',
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            columns().then(res => {
                if(res){
                    this.tableData = res.data;
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.dialogTitle = '修改栏目'
                this.id        = row.id
                this.name      = row.title
                this.path      = row.path
                this.identify  = row.identify
                this.sort      = row.sort_id
                this.status    = row.status
                this.is_module = row.is_module
                this.pid       = row.pid
            }else{
                this.dialog      = true
                this.dialogTitle = '添加栏目'
                this.id        = ''
                this.name      = ''
                this.path      = ''
                this.identify  = ''
                this.sort      = 1
                this.status    = 0
                this.is_module = 0
                this.pid       = ''
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                title:this.name,
                path:this.path,
                identify:this.identify,
                sort_id:this.sort,
                status:this.status,
                is_module:this.is_module,
                pid:this.pid,
            }
            columns_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改栏目函数
        handlePut(){
            let params = {
                title:this.name,
                path:this.path,
                identify:this.identify,
                sort_id:this.sort,
                status:this.status,
                is_module:this.is_module,
                pid:this.pid,
            }
            columns_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                    
                }
            })
        },
        // 修改排序
        handleSort(row){
            let params = {
                sort_id:row.sort_id
            }
            columns_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改状态
        handleStatus(row){
            let params = {
                status:row.status
            }
            columns_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 点击删除 
        handleDel(item){
            console.log(item)
            this.$confirm(`此操作将删除 ${item.title} 角色, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                columns_del(item.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.id)
            })
        },
        // 批量操作  1 启用 2 禁用 3 删除
        handleBatch(index){
            if(this.ids.length == 0){
                this.$message({type:'error',message:'请至少选中一条数据进行批量操作哦',})
                return false;
            }
            if(index == 1){
                let params = {
                    status:1
                }
                columns_put(this.ids,params).then(res => {
                    if(res){
                        this.handleData()
                        this.$message({type:'success',message:res.msg,duration:1500})
                    }
                })
            }else if(index == 2){
                let params = {
                    status:0
                }
                columns_put(this.ids,params).then(res => {
                    if(res){
                        this.handleData()
                        this.$message({type:'success',message:res.msg,duration:1500})
                    }
                })
            }else if(index == 3){
                this.$confirm(`此操作将删除所有选中的栏目, 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                   columns_del(this.ids).then(res => {
                        this.$message({type:'success',message:res.msg})
                        this.handleData();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        },
    },
    created(){
        this.handleData();
    }
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>